import { Loader2, Sparkles, ArrowRight } from "lucide-react"
import { siteConfig } from "@/components/homepage/_config"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"

export function CTA({
    onSignUp,
}: {
    onSignUp: () => void
}) {
    const { ctaSection } = siteConfig

    return (
        <section
            id={ctaSection.id}
            className="relative flex flex-col items-center justify-center px-4 py-20 md:py-32 overflow-hidden"
        >
            <div className="absolute inset-0 z-0 h-full w-full bg-radial-[at_45%_85%] from-[#2CD5FF]/40 via-[#2C30FF]/4 mask-[linear-gradient(to_bottom,transparent,black_100%)]" />
            <div className="absolute inset-0 z-0 h-full w-full bg-radial-[at_45%_68%] from-[#2CD5FF]/68 via-[#2C30FF]/3 mask-[linear-gradient(to_bottom,transparent,black_100%)] blur-[50px]" />

            {/* Content */}
            <div className="relative z-10 flex flex-col items-center justify-center text-center space-y-6 max-w-4xl mx-auto">
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium tracking-tighter text-balance">
                    {ctaSection.title}
                </h2>
                <p className="text-muted-foreground text-center text-balance font-medium max-w-2xl mx-auto">
                    {ctaSection.subtext}
                </p>

                <div className="pt-2">
                    <Button
                        onClick={onSignUp}
                        size="lg"
                        className={cn(
                            "signup-btn group rounded-full px-10 py-7 text-lg font-medium text-primary-foreground cursor-pointer",
                            "bg-sky-500",
                            "shadow-[0px_1px_2px_0px_#00000016,0px_2px_4px_0px_#00000006]",
                            "ring-0 hover:bg-sky-500/90",
                            "[&.is-loading_.idle-content]:hidden [&.is-loading_.loading-content]:inline-flex [&.is-loading]:opacity-70 [&.is-loading]:pointer-events-none",
                        )}
                    >
                        <span className="loading-content hidden items-center">
                            <Loader2 className="size-4 mr-2 animate-spin" />
                            Getting started...
                        </span>
                        <span className="idle-content inline-flex items-center">
                            <Sparkles className="size-4 mr-2 transition-transform duration-300 group-hover:rotate-30" />
                            Get started – it's free
                            <ArrowRight className="size-4 ml-2 transition-transform duration-300 group-hover:translate-x-1" />
                        </span>
                    </Button>
                </div>
            </div>
        </section>
    )
}
